import React, { useContext } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';

const StationHeader = observer(props => {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);

  const handleClick = direction =>{
    if (!direction) return;

    viewStore.setServiceDirection(direction);
  };

  const getDirections = () => {
    if (!locationStore.messages || !locationStore.messages.directions || locationStore.messages.directions.length < 1) return '';

    if (props.direction) {
      const direction = locationStore.messages.directions.find(d => d.direction === props.direction);
      let directionText = 'No Trips Found';

      if (direction) {
        directionText = direction.directionText.find(d => d.language === viewStore.languageName);
      }

      return (
        <button className="direction-button active" onClick={() => handleClick(props.direction)}>
          {directionText !== undefined ? directionText.text : 'No Trips Found'}
        </button>
      );
    }

    return locationStore.messages.directions.map(d => {
      const directionText = d.directionText.find(dt => dt.language === viewStore.languageName);

      return (
        <button key={d.direction} className={`direction-button ${d.direction.toLowerCase()} ${viewStore.serviceDirection === d.direction ? 'active' : ''}`} onClick={() => handleClick(d.direction)}>
          {directionText !== undefined ? directionText.text : 'No Trips Found'}
        </button>
      );
    });
  };

  return (
    <div className="direction-header">
      {getDirections()}
    </div>
  );
});

export default StationHeader;
